/* The platform totals page (UX-11): the range, the tiles (the mockup's `.tiles`), the chart and the table. */
.view {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  min-width: 0;
}

.tiles {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: var(--space-4);
}

@media (max-width: 1279px) {
  .tiles {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.tile {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  padding: var(--space-4);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  background: var(--surface-raised);
}

.tile p {
  margin: 0;
}

.tileLabel {
  font-size: var(--font-size-13);
  color: var(--text-muted);
}

.tileValue {
  margin-top: var(--space-1) !important;
  font-size: var(--font-size-32);
  font-weight: var(--font-weight-semibold);
  letter-spacing: -0.02em;
  line-height: 1.2;
  font-variant-numeric: tabular-nums;
  overflow-wrap: anywhere;
}

.tileContext {
  font-size: var(--font-size-12);
  color: var(--text-subtle);
}

.skeleton {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.skeletonRows {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.range {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: var(--space-3);
  margin: 0;
  padding: 0;
  border: 0;
}

.legend {
  padding: 0;
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-medium);
}

.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: var(--font-size-13);
}

.date {
  box-sizing: border-box;
  block-size: var(--control-height);
  padding: 0 10px;
  border: 1px solid var(--border-control);
  border-radius: var(--radius-control);
  background: var(--surface-raised);
  color: var(--text);
  font: inherit;
  font-size: var(--font-size-13);
}

.date:focus-visible,
.chart:focus-visible,
.toggle:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

.hint,
/* Owner 2026-10-19: the covered range and "Exportar CSV" of that range, on one line. */
.periodRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
}

.period {
  margin: 0;
  font-size: var(--font-size-12);
  color: var(--text-muted);
}

.scroll {
  overflow-x: auto;
}

/* The mockup's `.table`: 13px rows of 48px, muted 12px headings, tabular figures. */
.table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--font-size-13);
  font-variant-numeric: tabular-nums;
}

.table th,
.table td {
  padding: var(--space-2) var(--space-3);
  border-bottom: 1px solid var(--border);
  text-align: right;
  white-space: nowrap;
}

.table td {
  block-size: 48px;
}

.table thead th {
  font-size: var(--font-size-12);
  font-weight: var(--font-weight-medium);
  color: var(--text-muted);
}

.table tbody th {
  font-weight: var(--font-weight-medium);
}

.table tbody tr:hover {
  background: var(--state-hover);
}

.table th[scope="row"],
.table thead th:first-child {
  text-align: left;
}

.table tfoot th,
.table tfoot td {
  border-bottom: 0;
  font-weight: var(--font-weight-semibold);
}

.detail {
  display: grid;
  grid-template-columns: max-content max-content;
  gap: 0.25rem 1rem;
  margin: 0;
  text-align: left;
}

.detail dd {
  margin: 0;
}

.toggle {
  padding: 0;
  border: 0;
  background: none;
  color: var(--action-text);
  font: inherit;
  text-decoration: underline;
  cursor: pointer;
}

.figure {
  margin: 0;
}

/* Drawn at its own 640px scale (12px labels), never stretched to the page width. */
.chart {
  display: block;
  width: 100%;
  max-inline-size: 640px;
  height: auto;
  color: var(--text);
}

.bar {
  fill: var(--action-surface);
}

.chartLabel {
  fill: currentColor;
  font-size: 12px;
}

.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
